module.exports = __webpack_public_path__ + "static/media/concert.b985478c.png";